import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {IMAGES_URL} from "modules";

export const positionA1 = {
	squadId: 1,
	namegroup: Groups.A,
	position: 1,
};

export const helpLinks = [
	{
		url: "/help/guidelines",
		key: "help.fifa.how_to",
	},
	{
		url: "/help/prizes",
		key: "help.fifa.prizes",
	},
	{
		url: "/help/faqs",
		key: "help.fifa.faqs",
	},
	{
		url: "/help/terms",
		key: "help.fifa.terms",
	},
];

export const LOCKED_PREDICTION = {
	squadId: 1,
	namegroup: "a",
	position: 1,
};

export const LOCKED_SQUAD = {
	id: 1,
	name: "Qatar",
	shortName: "QAT",
	confederation: "afc",
	group: "a",
	position: 1,
	pot: 1,
};

export const IS_PRE_REGISTRATION = JSON.parse(
	process.env.REACT_APP_IS_PRE_REGISTRATION || "false"
) as boolean;
export const IS_PRE_DRAW = JSON.parse(process.env.REACT_APP_IS_PRE_DRAW || "false") as boolean;

export const FLAGS_URL = `${IMAGES_URL}flags/`;
